module.exports = __webpack_public_path__ + "img/recommed-img4.8c2b402e.jpg";